import { Reveal } from "../Reveal";
import { STORY_IMAGES, MENU_ITEMS } from "../../lib/content";

const galleryTiles = [
  { src: STORY_IMAGES.interior, span: "md:col-span-7 md:row-span-2", aspect: "aspect-[4/3]" },
  { src: STORY_IMAGES.desserts, span: "md:col-span-5", aspect: "aspect-square" },
  { src: STORY_IMAGES.paperBag, span: "md:col-span-3", aspect: "aspect-square" },
  { src: STORY_IMAGES.brandSign, span: "md:col-span-2", aspect: "aspect-square" },
  { src: STORY_IMAGES.cupBranded, span: "md:col-span-2", aspect: "aspect-square" },
];

export default function Gallery() {
  return (
    <section
      id="atmosphere"
      data-testid="gallery-section"
      className="relative bg-cream py-24 md:py-40"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-7">
            <Reveal>
              <div className="flex items-center gap-4 mb-6">
                <span className="overline text-matcha-dark">— Chapter Four</span>
                <span className="h-px w-24 bg-ink/30" />
              </div>
              <h2
                className="font-serif font-light leading-[1] tracking-tight text-ink"
                style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
              >
                The room,
                <br />
                <span className="italic font-cormorant text-matcha-dark">
                  the light, the bowl.
                </span>
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
            <Reveal delay={0.1}>
              <p className="text-ink-soft leading-relaxed">
                A counter washed in soft white. Sage walls. A grinder humming
                quietly behind the espresso machine. We made the room we
                wanted to drink in.
              </p>
            </Reveal>
          </div>
        </div>

        {/* Asymmetric photo grid */}
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {galleryTiles.map((t, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              className={`col-span-12 ${t.span}`}
            >
              <div
                className={`relative w-full ${t.aspect} overflow-hidden rounded-sm group`}
              >
                <img
                  src={t.src}
                  alt={`Atmosphere ${i + 1}`}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
                />
              </div>
            </Reveal>
          ))}
        </div>

        {/* Marquee */}
        <div className="mt-24 md:mt-32 overflow-hidden border-y border-ink/15 py-6">
          <div className="flex whitespace-nowrap animate-marquee">
            {Array.from({ length: 2 }).map((_, k) => (
              <div key={k} className="flex items-center shrink-0">
                {[
                  "Hand-whisked",
                  "Stone-ground",
                  "Slow craft",
                  "First-flush only",
                  "Made to order",
                ].map((w, i) => (
                  <span key={i} className="flex items-center">
                    <span
                      className="font-serif italic text-ink/80 px-8"
                      style={{ fontSize: "clamp(1.75rem, 3.5vw, 3rem)" }}
                    >
                      {w}
                    </span>
                    <span className="text-matcha-dark text-2xl">·</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
